export default "__VITE_ASSET__D15rFzEm__"